import Image from "common/components/Image";
import { OnboardingClientEventKind } from "common/types/onboarding";
import LinkButton from "common/components/LinkButton";
import { toPhone } from "common/utils/formatting";

import Button from "client/common/components/buttons/Button";
import { OnboardingSubscriptionsStepParams } from "client/onboarding/types";
import { useClinic } from "client/clinics/hooks";
import { useOnboardingEventsMutation } from "client/onboarding/hooks";
import { urls } from "client/routes";

import StepLayout from "../OnboardingSubscriptionsStepLayout";
import complete from "../../images/complete.svg";

import styles from "../../styles/OnboardingSubscriptionsCompleteStep.module.less";

const OnboardingSubscriptionsCompleteStep = ({ stepper }: OnboardingSubscriptionsStepParams) => {
  const {
    previous_pharmacy_url: legacyPharmacyUrl,
    phone_number: phoneNumber,
    email,
  } = useClinic();

  // We don't want to surface any error / loading state to the client if the below fails
  const { mutate: createEvent } = useOnboardingEventsMutation({});

  const renderContactText = () => {
    const phoneDisplay = phoneNumber && (
      <LinkButton href={`tel:${phoneNumber}`} className={styles.link}>
        {toPhone(phoneNumber)}
      </LinkButton>
    );
    const emailDisplay = email && (
      <LinkButton href={`mailto:${email}`} className={styles.link}>
        {email}
      </LinkButton>
    );
    if (phoneDisplay && emailDisplay) {
      return (
        <>
          {" "}
          at {emailDisplay} or {phoneDisplay}
        </>
      );
    }
    if (phoneDisplay) {
      return <> at {phoneDisplay}</>;
    }
    if (emailDisplay) {
      return <> at {emailDisplay}</>;
    }
    return null;
  };

  return (
    <StepLayout stepper={stepper}>
      <div className={styles.heading}>
        <Image className={styles.image} src={complete} alt="Dog" />
        <StepLayout.Title>One last step!</StepLayout.Title>
        <StepLayout.Description>
          <p>
            Please remember to go to our old online store to cancel your existing autoship. For
            assistance, please contact us{renderContactText()}.
          </p>
          <p>You may also set up an account on our new store to manage your Autoships.</p>
        </StepLayout.Description>
      </div>
      <StepLayout.Footer>
        {!!legacyPharmacyUrl && (
          <Button
            href={legacyPharmacyUrl}
            onClick={() => {
              createEvent({ kind: OnboardingClientEventKind.LegacyPharmacyLinkClicked });
            }}
          >
            Go to old store
          </Button>
        )}
        <Button variant="secondary" dest={urls.accounts.signup()}>
          Create new account
        </Button>
      </StepLayout.Footer>
    </StepLayout>
  );
};

export default OnboardingSubscriptionsCompleteStep;
